<template>
  <div class="row mt-4">
    <div class="col-6">
      <span class="mr-4">
        <router-link
          class="ln-primary"
          :to="{
            name: `list`,
            params: { searchCache: searchCache, loadFromCache: loadFromCache },
          }"
        >
          <font-awesome-icon icon="arrow-left" class="ln-primary mr-2" />
          Atgal
        </router-link>
      </span>
    </div>
    <div class="col-6 text-right">
      <div class="ln-rating-container">
        <b-form-rating
          v-if="isAuthenticated"
          inline
          value="0"
          no-border
          variant="primary"
          @change="ratingChange"
          class="ln-rating"
        ></b-form-rating>
      </div>
    </div>
  </div>
</template>

<script>
import SearchUrlParams from "../../_Helpers/search-url-params";
import { userService } from "../../_Services/user-service";
import { PutDocumentRating } from "../../Assets/repository";
export default {
  name: "document-header",
  props: {
    fileGuid: String,
    searchCache: {
      type: Object,
      default: () => {
        return {
          documentList: undefined,
          currentPage: 0,
          resultPerPage: 10,
        };
      },
    },
  },
  created() {
    if (!this.loadFromCache) SearchUrlParams.clearSessionStorage();
  },
  computed: {
    loadFromCache() {
      return this.searchCache.documentList !== undefined;
    },
    isAuthenticated() {
      return userService.isAuthorized();
    },
  },
  methods: {
    ratingChange(value) {
      const docId = this.$route.params.id;
      PutDocumentRating(docId, value);
    },
  },
};
</script>

<style lang="scss" scoped></style>
